import React, { useState, useEffect } from "react";
import { GROUPS, getCellColor } from "../../../components/baserunning-report";
import { API_BASE_URL } from "../../../config/api";

const WIDTH = 1056;
const HEIGHT = 816;

export const BaserunningReportRender = () => {
  const [ready, setReady] = useState(false);
  const config = window.__BASERUNNING_CONFIG__ ||
    JSON.parse(sessionStorage.getItem("baserunningConfig") || "{}") || {};
  const { rows = [], colorRanges = {}, report = {} } = config;

  useEffect(() => {
    setReady(true);
  }, []);

  return (
    <div
      data-export-ready={ready ? "true" : undefined}
      className="bg-white overflow-hidden"
      style={{ width: WIDTH, height: HEIGHT }}
    >
      <div className="bg-gradient-to-r from-blue-800 to-blue-600 px-8 py-5 flex items-center justify-between">
        <div className="flex items-center gap-5">
          {report.teamId && (
            <div className="w-14 h-14 rounded-xl overflow-hidden bg-white/10 ring-2 ring-white/20 flex-shrink-0">
              <img
                src={`${API_BASE_URL}/api/team-logo/${report.teamId}`}
                alt={report.teamName}
                className="w-full h-full object-contain p-1"
                onError={(e) => { e.currentTarget.style.display = "none"; }}
              />
            </div>
          )}
          <div>
            <div className="text-2xl font-bold text-white">{report.teamName}</div>
            <div className="text-blue-200 text-sm mt-0.5">Baserunning Report · {report.year}</div>
          </div>
        </div>
        <div className="flex items-center gap-5">
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded" style={{ background: "rgb(254,202,202)" }} />
            <span className="text-blue-100 text-xs">Below avg</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded" style={{ background: "rgb(187,247,208)" }} />
            <span className="text-blue-100 text-xs">Above avg</span>
          </div>
        </div>
      </div>

      <div className="px-8 pt-5 flex flex-col items-center">
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 9, boxShadow: "0 1px 3px rgba(0,0,0,0.06)", borderRadius: 8, overflow: "hidden" }}>
          <thead>
            <tr>
              {GROUPS.map((g, gi) => (
                <th
                  key={gi}
                  colSpan={g.cols.length}
                  style={{
                    padding: "3px 4px",
                    textAlign: g.label === "Player" ? "left" : "center",
                    fontSize: 8,
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: "0.06em",
                    color: g.label ? "#4338ca" : "transparent",
                    background: g.label ? "#eef2ff" : "#f9fafb",
                    borderBottom: "1px solid #c7d2fe",
                    borderRight: gi < GROUPS.length - 1 ? "2px solid #c7d2fe" : "none",
                  }}
                >
                  {g.label}
                </th>
              ))}
            </tr>
            <tr style={{ background: "#f8fafc" }}>
              {GROUPS.flatMap((g, gi) =>
                g.cols.map((col, ci) => (
                  <th
                    key={col.key}
                    style={{
                      padding: "3px 5px",
                      textAlign: col.align === "left" ? "left" : "center",
                      fontSize: 9,
                      fontWeight: 600,
                      color: "#374151",
                      whiteSpace: "nowrap",
                      borderBottom: "2px solid #d1d5db",
                      borderRight:
                        ci === g.cols.length - 1 && gi < GROUPS.length - 1
                          ? "2px solid #c7d2fe"
                          : "1px solid #e5e7eb",
                    }}
                  >
                    {col.label}
                  </th>
                ))
              )}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, ri) =>
              <tr key={row.player_id ?? ri} style={{ background: ri % 2 === 0 ? "#fff" : "#f9fafb" }}>
                {GROUPS.flatMap((g, gi) =>
                  g.cols.map((col, ci) => {
                    const raw = col.getValue ? col.getValue(row) : row[col.key];
                    const display = col.format ? col.format(raw) : (raw ?? "—");
                    const bg = col.colored
                      ? getCellColor(raw != null ? Number(raw) : null, colorRanges?.[col.key])
                      : null;
                    return (
                      <td
                        key={col.key}
                        style={{
                          padding: "4px 5px",
                          textAlign: col.align === "left" ? "left" : "center",
                          fontWeight: col.bold ? 700 : 400,
                          fontSize: col.align === "left" ? 10 : 9,
                          whiteSpace: "nowrap",
                          backgroundColor: bg ?? (ri % 2 === 0 ? "#fff" : "#f9fafb"),
                          borderBottom: "1px solid #f3f4f6",
                          borderRight:
                            ci === g.cols.length - 1 && gi < GROUPS.length - 1
                              ? "2px solid #e0e7ff"
                              : "1px solid #f3f4f6",
                          color: col.bold ? "#1e3a8a" : "#111827",
                        }}
                      >
                        {display}
                      </td>
                    );
                  })
                )}
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="absolute bottom-4 left-0 right-0 text-center">
        <span className="text-gray-300 text-[9px]">
          Generated by D3 Dashboard · {new Date().toLocaleDateString()}
        </span>
      </div>
    </div>
  );
};
